import { putPromise } from "./request-promise";
import { UtilizationGoalDataInterface, UtilizationGoalParams } from "@app/models/chart-data.model";

export function addUpdateUtilizationGoals(utilizationGoalParams: Pick<UtilizationGoalParams, 'siteId'> | UtilizationGoalParams) {
    return putPromise<{ data: UtilizationGoalDataInterface[]; message: string }>(
        '/api/dashboards/highchart_analytics/create_update_drilling_goal',
        utilizationGoalParams,
        (data) => data || null
    );
}
